import { createSlice } from "@reduxjs/toolkit"
import {
  addQuestion,
  deleteQuestion,
  getAllBranchRatings,
  getAllRatingQuestions,
  getAllRatings,
  getBranchRatingDetails,
  getQuestionDetails,
  updateQuestion,
  updateQuestionStatus,
} from "store/actions/ratingsAction"

const initialState = {
  loading: true,
  itemsPerPage: 10,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  ratings: [],
  ratingQuestions: [],
  questionDetails: {},
  isLoading: false,
  branchRatings: [],
  branchRatingDetails: {},
}

const usersSlice = createSlice({
  name: "ratings",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET RATINGS
    builder
      .addCase(getAllRatings.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getAllRatings.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action?.payload
          state.ratings = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllRatings.rejected, (state, action) => {
        state.loading = false
      })

    // GET RATING QUESTIONS
    builder
      .addCase(getAllRatingQuestions.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getAllRatingQuestions.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action?.payload
          state.ratingQuestions = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllRatingQuestions.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE QUESTION STATUS
    builder
      .addCase(updateQuestionStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateQuestionStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.ratingQuestions = state.ratingQuestions.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateQuestionStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE RATING QUESTION
    builder
      .addCase(deleteQuestion.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteQuestion.fulfilled, (state, action) => {
        const { status } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.ratingQuestions = state.ratingQuestions.filter(
            item => item._id !== id
          )
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteQuestion.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD QUESTION
    builder
      .addCase(addQuestion.pending, state => {
        state.isLoading = true
      })
      .addCase(addQuestion.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addQuestion.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPDATE QUESTION
    builder
      .addCase(updateQuestion.pending, state => {
        state.isLoading = true
      })
      .addCase(updateQuestion.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateQuestion.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET FAQ DETAILS
    builder
      .addCase(getQuestionDetails.pending, state => {
        state.loading = true
        state.questionDetails = {}
      })
      .addCase(getQuestionDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.questionDetails = data
        }
      })
      .addCase(getQuestionDetails.rejected, (state, action) => {
        state.loading = false
      })

    // BRANCH RATINGS
    // GET RATING QUESTIONS
    builder
      .addCase(getAllBranchRatings.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
        state.branchRatings = []
      })
      .addCase(getAllBranchRatings.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          const { totalCount, totalPages, currentPage } = action?.payload
          state.branchRatings = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllBranchRatings.rejected, (state, action) => {
        state.loading = false
      })

    // GET BRANCH RATING DETAILS
    builder
      .addCase(getBranchRatingDetails.pending, state => {
        state.loading = true
        state.branchRatingDetails = {}
      })
      .addCase(getBranchRatingDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.branchRatingDetails = data
        }
      })
      .addCase(getBranchRatingDetails.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default usersSlice.reducer
